export const brandFonts = {
  primary: "'Montserrat', sans-serif",
};
